<template>
  <div class="big">
    <div class="page_title">客户关系查询</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>分销员</span>
            <el-input
              v-model="commission_user_name"
              style="width: 130px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>手机号</span>
            <el-input
              v-model="commission_phone"
              style="width: 130px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>客户昵称</span>
            <el-input
              v-model="nick_name"
              style="width: 130px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>

          <div class="item">
            <span>客户昵称手机号</span>
            <el-input
              v-model="phone"
              style="width: 130px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>

          <div class="item">
            <span>是否有效</span>
            <el-radio-group v-model="status">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>

          <div class="item">
            <span>客户关联时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 225px; margin-left: 6px"
              @change="search"
            >
            </el-date-picker>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 6px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              label="分享人"
              align="center"
              prop="commission_user_name"
            >
            </el-table-column>

            <el-table-column
              label="分享人手机号"
              prop="commission_phone"
              class-name="border-column"
              align="center"
            ></el-table-column>

            <el-table-column
              label="是否为星推官"
              prop="status"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.star_label_id > 0 ? "是" : "否" }}</span>
                <span v-if="scope.row.star_label_id"
                  >({{ scope.row.star_label_name }})</span
                >
              </template>
            </el-table-column>

            <el-table-column
              label="客户昵称"
              prop="nick_name"
              class-name="border-column"
              align="center"
            ></el-table-column>

            <el-table-column
              label="客户昵称手机号"
              prop="phone"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.phone != '查看更多'">{{
                  scope.row.phone
                }}</span>
                <span
                  class="main-color"
                  style="cursor: pointer"
                  v-if="scope.row.phone == '查看更多'"
                  @click="showMore(scope.row)"
                  >查看更多</span
                >
              </template>
            </el-table-column>

            <el-table-column
              label="是否有效"
              prop="status"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.phone == '查看更多'"></span>
                <span v-else>{{ scope.row.phone ? "有效" : "无效" }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="客户关联时间"
              prop="create_time"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | dateFormat }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="客户绑定时间"
              prop="bind_time"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.bind_time | dateFormat }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 更多弹窗 -->
    <el-dialog
      title="更多客户昵称"
      :visible.sync="extraShow"
      width="800px"
      style="text-align: left"
      center
    >
      <div style="padding: 20px">
        <div style="border: solid 1px #c9cbd6">
          <el-table
            :data="extraData"
            tooltip-effect="dark"
            style="width: 100%"
            height="500px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column prop="nick_name" label="客户昵称" align="center" />
            <el-table-column prop="phone" label="客户昵称手机号" align="center">
            </el-table-column>
            <el-table-column
              label="客户关联时间"
              prop="create_time"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | dateFormat }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否有效"
              prop="status"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.phone ? "有效" : "无效" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="客户绑定时间"
              prop="bind_time"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.bind_time | dateFormat }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      commission_user_name: "",
      commission_phone: "",
      nick_name: "",
      status: "",
      phone: "",
      date: [],
      extraShow: false,
      extraData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        commission_user_name: this.commission_user_name,
        commission_phone: this.commission_phone,
        nick_name: this.nick_name,
        status: this.status,
        phone: this.phone,
      };
      if (this.date && this.date.length) {
        data.start_create_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_create_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        // .post("platform/Distribution/customerRelationshipList", data)
        .post("platform/StarSalesman/customerRelationshipList", data)
        .then((res) => {
          if (res.code == 0) {
            this.fomartList(res.data.list);
            this.totalNum = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //格式化列表
    fomartList(list) {
      let arr = [];
      list.forEach((ele) => {
        if (ele.item_list.length > 0) {
          let children = [];
          ele.item_list.forEach((item, index) => {
            let obj = {
              user_id: ele.user_id,
              star_label_id: ele.star_label_id,
              star_label_name: ele.star_label_name,
              commission_user_name: ele.commission_user_name,
              commission_phone: ele.commission_phone,
              user_id_m: item.rule_id,
              nick_name: item.nick_name,
              phone: item.phone,
              create_time: item.create_time,
              bind_time: item.bind_time,
              status: item.status,
            };
            if (index <= 9) {
              arr.push(obj);
              children.push(obj);
            } else {
              children.push(obj);
            }
          });
          if (ele.item_list.length > 10) {
            let obj = {
              user_id: ele.user_id,
              commission_user_name: ele.commission_user_name,
              commission_phone: ele.commission_phone,
              phone: "查看更多",
              children: children,
            };
            arr.push(obj);
          }
        }
        // else {
        //   ele.user_id_m = "";
        //   ele.nick_name = "";
        //   ele.phone = "";
        //   ele.create_time = "";
        //   arr.push(ele);
        // }
      });
      this.tableData = arr;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (columnIndex == 0 || columnIndex == 1 || columnIndex == 2) {
        this.tableData.forEach((ele) => {
          if (row.user_id == ele.user_id) {
            num++;
          }
        });
      }

      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].user_id ==
            this.tableData[rowIndex - 1].user_id
        ) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        } else {
          return {
            rowspan: num,
            colspan: 1,
          };
        }
      }
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        phone: this.phone,
        nick_name: this.nick_name,
        order_value: this.order_value,
      };
      if (this.date && this.date.length) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Distribution/exportDistributor", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //多选
    handleSelectionChange(val) {
      let arr = val.map((item) => {
        return item.ca_id;
      });
      this.ca_ids = arr.toString();
    },
    //退回/确认
    checkApply(ca_id, status) {
      let loading = this.$loading({
        text: "操作正在执行中，请不要关闭或者退出当前页面",
      });
      let msg = "是否同意本次提现？";
      if (status == 3) {
        msg = "是否确认退回，提现金额将退回分销员账户？";
      }
      this.$confirm(`${msg}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            ca_id,
            status,
          };
          this.axios
            .post("platform/Distribution/checkStatus", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    },
    //批量退回/确认
    checkApplyAll(status) {
      if (!this.ca_ids) {
        this.$message.error("请先选择需要操作的数据");
        return false;
      }
      let loading = this.$loading({
        text: "操作正在执行中，请不要关闭或者退出当前页面",
      });
      let msg = "是否同意本次提现？";
      if (status == 3) {
        msg = "是否确认退回，提现金额将退回分销员账户？";
      }
      this.$confirm(`${msg}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            ca_ids: this.ca_ids,
            status,
          };
          this.axios
            .post("platform/Distribution/batchCheckStatus", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    },
    //超过10个时查看更多
    showMore(row) {
      console.log(row);
      let { children } = row;
      this.extraData = children.map((item) => {
        // item.bind_time = item.bind_time
        //   ? dayjs.unix(item.bind_time).format("YYYY-MM-DD HH:mm")
        //   : "";
        return item;
      });
      this.extraShow = true;
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.border-column {
  border-right: 1px solid #ebeef5;
}
</style>
